module.exports = __webpack_public_path__ + "static/img/jiudian.5e5f7a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiudian.png
// module id = tic8
// module chunks = 0